import { useAuthStore } from "../../store/auth.store";
import { useEffect, useState } from "react";
import { useVendorsStore } from "../../store/vendors.store";
import { useVendors } from "../../hook/partner/vendors.partner.hook";
import { PartnerApi } from "../../api/partner.api";
import { NavLink } from "react-router";
import { useBreadcrumbsStore } from "../../store/breadcrumbs.store";
import { useCompanyStore } from "../../store/company.store";
import { useCompany } from "../../hook/partner/company.partner.hook";
import { useUsers } from "../../hook/partner/users.partner.hook";
import { useUserRoleSchema } from "../../hook/partner/userRoleSchema.partner.hook";
import { useUsersStore } from "../../store/users.store";
import { Role } from "../../utils/Role";
import { toast } from "react-toastify";
import UserNewModal from "../../components/modals/user/UserNewModal";
import UserUsernameNewModal from "../../components/modals/user/UserUsernameNewModal";
import { Accordion } from "react-bootstrap-accordion";
import "react-bootstrap-accordion/dist/index.css";
import { useTranslation } from "../../hooks/useTranslation";

function SettingsUsers() {
  const { t } = useTranslation();
  const usersMutation = useUsers();
  const roleSchemaMutation = useUserRoleSchema();
  const companyMutation = useCompany();
  const user = useAuthStore((state) => state.user);
  const [currentBranchId, setCurrentBranchId] = useState(0);

  const token = useAuthStore((state) => state.token);
  const userCurrent = useAuthStore((state) => state.user);
  const users = useUsersStore((state) => state.users);
  const roleSchema = useUsersStore((state) => state.roleSchema);

  const company = useCompanyStore((state) => state.company);
  const company_id = user?.current_person?.company_id;

  const [uniqueGroupIds, setGroups] = useState([]);
  const [showTab, setShowTab] = useState(false);

  const [reload, setReload] = useState(0);

  const [checkedUsers, setCheckedUsers] = useState([]);

  const [showUserNewModal, setShowUserNewModal] = useState(false);
  const [showUsernameNewModal, setShowUsernameNewModal] = useState(false);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("settings.title"));
    setBreadcrumbs([]);
  }, []);

  /*useEffect(() => {
    setCheckedUsers([]);
  }, [users]);*/

  useEffect(() => {
    if (token) {
      usersMutation.mutate({
        token,
      });

      companyMutation.mutate({
        token, company_id
      })

      roleSchemaMutation.mutate({
        token,
      });
    }
  }, [token, reload, company_id]);

  useEffect(() => {
    if (roleSchema?.length > 0) {
      setGroups([...new Set(roleSchema.map((item) => item.group_id))]);
    }
  }, [roleSchema]);

  if (
    reload == 0 &&
    (usersMutation.isLoading || roleSchemaMutation.isLoading)
  ) {
    return <p>{t("common.loading")}</p>;
  }

  const createUsername = (person_id, login) => {
    const result = PartnerApi.userAddUsername({
      token,
      person_id: person_id,
      username: login,
      company_branch_id: currentBranchId
    });
    result.then((result) => {
      if ("error" in result && result.code >= 300) {
        toast.error(result.error);
        return;
      } else if ("error" in result) {
        setReload(reload + 1);
        toast.success(result.error);
      }
    });
    return false;
  };

  const changeRole = (person_id, role_id, value) => {
    const result = PartnerApi.userRoleChange({
      token,
      person_id,
      role_id,
      value,
      company_branch_id: currentBranchId
    });
    result.then((result) => {
      if ("error" in result) {
        toast.error(result.error);
        return;
      }
      toast.success(t("common.saved"));
    });
    return false;
  };

  const deleteLogin = (person_id, username) => {
    if (!window.confirm(t("common.delete") + "?")) {
      return;
    }

    const result = PartnerApi.userDeleteUsername({
      token,
      person_id,
      username,
      company_branch_id: currentBranchId
    });
    result.then((result) => {
      if ("error" in result) {
        setReload(reload + 1);
        toast.error(result.error);
        return;
      }
      setReload(reload + 1);
      toast.success(t("users.accessDeleted"));
    });
    return false;
  };

  const hromadnaZmena = (role_id, val) => {
    if (val && val !== "" && checkedUsers.length > 0) {
      if (!window.confirm(t("users.confirmBulkEdit"))) {
        return false;
      }

      const result = PartnerApi.updateRoleMultipleUsers({
        token,
        data: { role_id: role_id, value: val, person_id: checkedUsers,
          company_branch_id: currentBranchId },
      });
      result.then((result) => {
        if ("error" in result) {
          setReload(reload + 1);
          toast.error(result.error);
          return;
        }
        setReload(reload + 1);
        toast.success(t("users.bulkEditDone"));
      });
      return false;
    }
    return false;
  };

  const deleteUser = (person_id) => {
    if (!window.confirm(t("common.delete") + "?")) {
      return;
    }

    const result = PartnerApi.userDelete({
      token,
      id: person_id,
      company_branch_id: currentBranchId
    });
    result.then((result) => {
      if ("error" in result) {
        setReload(reload + 1);
        toast.error(result.error);
        return;
      }
      setReload(reload + 1);
      toast.success(t("users.userDeleted"));
    });
    return false;
  };

  return (
    <>
      {users && "error" in users ? (
        <p className="alert alert-danger">{users.error}</p>
      ) : (
        <>
          <UserNewModal show={showUserNewModal}
              handleClose={()=>setShowUserNewModal(false)}
              callback={() => setReload(reload + 1)}
          />
          {Role.hasRole(userCurrent, "userAdmin", "1") && (
            <div className="mb-4">
              <button
                className="btn btn-primary me-3"
                onClick={()=>setShowUserNewModal(true)}
              >
                <i className="ki-duotone ki-plus fs-4">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                </i>
                {t("users.addPerson")}
              </button>
              {showTab ? (
                <button
                  className="btn btn-info"
                  onClick={() => setShowTab(false)}
                >
                  {t("users.switchToOverview")}
                </button>
              ) : (
                <button
                  className="btn btn-info"
                  onClick={() => setShowTab(true)}
                >
                  {t("users.switchToBulkTable")}
                </button>
              )}
            </div>
          )}

          {company?.branches?.length > 0 && (

              <ul className="mb-10 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                <li className="nav-item">
                    <span onClick={() => setCurrentBranchId(0)}
                          className={"cursor-pointer nav-link" + (currentBranchId == 0 ? " active" : "")}
                          aria-current="page"
                    >
                        Obecné
                    </span>
                </li>
                {company.branches.map(branch => (
                    <li className="nav-item">
                      <span onClick={() => setCurrentBranchId(branch.company_branch_id)}
                            className={"cursor-pointer nav-link" + (currentBranchId == branch.company_branch_id ? " active" : "")}
                            aria-current="page"
                      >
                          {branch.name}
                      </span>
                    </li>
                ))}
              </ul>
          )}

          {users && users.length > 0 ? (
            showTab ? (
              <div className="card">
                <div className="card-body">
                  <div className="sticky-2cols-table">
                    <table className="table table-striped table-bordered fs-8">
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th>&nbsp;</th>
                          {uniqueGroupIds?.map((g) => (
                            <th
                              colSpan={
                                roleSchema.filter((r) => r.group_id === g)
                                  .length
                              }
                            >
                              {g}
                            </th>
                          ))}
                        </tr>
                        <tr>
                          <th>&nbsp;</th>
                          <th>{t("common.name")}</th>
                          {uniqueGroupIds?.map((g) =>
                            roleSchema
                              .filter((r) => r.group_id === g)
                              .map((r) => <th>{r.description}</th>)
                          )}
                        </tr>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              checked={
                                checkedUsers.length ===
                                users.filter((user) => user.login.length > 0)
                                  .length
                              }
                              onChange={(e) =>
                                e.target.checked
                                  ? setCheckedUsers([
                                      ...new Set(
                                        users
                                          .filter(
                                            (user) => user.login.length > 0
                                          )
                                          .map((user) => user.person_id)
                                      ),
                                    ])
                                  : setCheckedUsers([])
                              }
                            />
                          </th>
                          <th>{t("users.selectEdit")}</th>
                          {uniqueGroupIds.map((g) =>
                            roleSchema
                              .filter((r) => r.group_id === g)
                              .map((r) => (
                                <th>
                                  <select
                                    style={{ maxWidth: "100px" }}
                                    disabled={
                                      !checkedUsers || checkedUsers.length === 0
                                    }
                                    onChange={(e) =>
                                      hromadnaZmena(r.role_id, e.target.value)
                                    }
                                  >
                                    <option value="">{t("users.selectEdit")}</option>
                                    {r.vals.map((v) => (
                                      <option value={v.val}>
                                        {v.description}
                                      </option>
                                    ))}
                                  </select>
                                </th>
                              ))
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {users?.filter(user=>(
                            user.company_branch_id==currentBranchId
                        )).map((user) => (
                          <tr key={user.person_id+"+"+user.company_branch_id}>
                            <td>
                              <input
                                type="checkbox"
                                disabled={user.login?.length == 0}
                                checked={
                                  checkedUsers?.findIndex(
                                    (l) => l === user.person_id
                                  ) >= 0
                                }
                                onChange={(e) =>
                                  e.target.checked
                                    ? setCheckedUsers([
                                        ...checkedUsers,
                                        user.person_id,
                                      ])
                                    : setCheckedUsers(
                                        checkedUsers.filter(
                                          (u) => u !== user.person_id
                                        )
                                      )
                                }
                              />
                            </td>
                            <td>
                              {user.first_name}&nbsp;{user.last_name}
                              <div>
                                {user.login?.length == 0 &&
                                  user.email &&
                                  user.email !== "" && (
                                    <a
                                      href="javascript:;"
                                      onClick={() =>
                                        createUsername(
                                          user.person_id,
                                          user.email
                                        )
                                      }
                                    >
                                      {t("users.connect", { email: user.email })}
                                    </a>
                                  )}
                              </div>
                            </td>
                            {uniqueGroupIds.map((g) =>
                              roleSchema
                                .filter((r) => r.group_id === g)
                                .map((r) => (
                                  <td>
                                    {user.login?.length == 0
                                      ? "--"
                                      : r.vals.find(
                                          (v) =>
                                            v.val ==
                                            Role.currentRole(
                                              r.role_id,
                                              user.role
                                            )
                                        )?.description}
                                  </td>
                                ))
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row">
                {users.filter(user=>(
                    user.company_branch_id==currentBranchId
                )).map((user, ukey) => (
                  <div className="col-sm-6 col-md-4 mb-6"  key={user.person_id+"+"+user.company_branch_id}>
                    <UserUsernameNewModal
                      show={showUsernameNewModal===user.person_id}
                      handleClose={()=>setShowUsernameNewModal(false)}
                      person_id={user.person_id}
                      callback={() => setReload(reload + 1)}

                    />

                    <div className="card h-100">
                      <div className="card-header">
                        <div className="card-title w-100">
                          <div className="d-flex align-items-center justify-content-between w-100">
                            <div>
                              {user.first_name} {user.last_name}
                            </div>
                            {Role.hasRole(userCurrent, "userAdmin", "1") && (
                              <button
                                className="btn btn-sm btn-danger float-right"
                                onClick={() => deleteUser(user.person_id)}
                              >
                                <i className="ki-duotone ki-trash fs-4 me-0 pe-0">
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                  <span className="path3"></span>
                                  <span className="path4"></span>
                                  <span className="path5"></span>
                                </i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {user.login.length === 0 ? (
                          <p className="alert alert-warning">
                            {t("users.noAccess")}
                          </p>
                        ) : (
                          <>
                            <h4>{t("users.permissionsSettings")}</h4>
                            {uniqueGroupIds?.map((g) => (
                              <Accordion title={g}>
                                {roleSchema &&
                                  roleSchema
                                    .filter((r) => r.group_id === g)
                                    .map((role, rkey) => (
                                      <div className="mb-4" key={rkey}>
                                        <h5>{role.description}</h5>
                                        {Role.hasRole(
                                          userCurrent,
                                          "userAdmin",
                                          "1"
                                        ) ? (
                                          <select
                                            className="form-select"
                                            defaultValue={Role.currentRole(
                                              role.role_id,
                                              user.role
                                            )}
                                            name={role.role_id}
                                            onChange={(e) =>
                                              changeRole(
                                                user.person_id,
                                                role.role_id,
                                                e.target.value
                                              )
                                            }
                                            disabled={
                                              role.role_id == "userAdmin" &&
                                              user.person_id ==
                                                userCurrent.current_person
                                                  .person_id
                                            }
                                          >
                                            {role.vals?.map((val, vkey) => (
                                              <option
                                                key={vkey}
                                                value={val.val}
                                              >
                                                {val.description}
                                              </option>
                                            ))}
                                          </select>
                                        ) : (
                                          <div>
                                            {Role.currentRoleValue(
                                              role.role_id,
                                              user.role,
                                              roleSchema
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    ))}
                              </Accordion>
                            ))}
                            <hr />
                            <h4>{t("users.connectedLogins")}</h4>
                            <table className="table table-bordered">
                              <tbody>
                                {user.login.map((login, lkey) => (
                                  <tr key={lkey}>
                                    <td>{login.username}</td>
                                    {Role.hasRole(
                                      userCurrent,
                                      "userAdmin",
                                      "1"
                                    ) && (
                                      <td>
                                        <button
                                          className="btn btn-sm btn-danger"
                                          onClick={() =>
                                            deleteLogin(
                                              user.person_id,
                                              login.username
                                            )
                                          }
                                        >
                                          <i className="ki-duotone ki-trash fs-4 me-0 pe-0">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                            <span className="path3"></span>
                                            <span className="path4"></span>
                                            <span className="path5"></span>
                                          </i>
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        )}

                        {Role.hasRole(userCurrent, "userAdmin", "1") && (
                          <div className="mb-4">
                            {user.has_login
                              ? (!user.login ||
                                  user.login.findIndex(
                                    (l) => l.username === user.email
                                  ) === -1) && (
                                  <button
                                    className="btn btn-sm btn-primary w-100 mb-3"
                                    onClick={() =>
                                      createUsername(user.person_id, user.email)
                                    }
                                  >
                                    <i className="ki-duotone ki-arrows-circle fs-4">
                                      <span className="path1"></span>
                                      <span className="path2"></span>
                                      <span className="path3"></span>
                                      <span className="path4"></span>
                                      <span className="path5"></span>
                                    </i>
                                    {t("users.connect", { email: user.email })}
                                  </button>
                                )
                              : user.email &&
                                user.email !== "" && (
                                  <button
                                    className="btn btn-sm btn-primary w-100 mb-3"
                                    onClick={() =>
                                      createUsername(user.person_id, user.email)
                                    }
                                  >
                                    <i className="ki-duotone ki-arrows-circle fs-4">
                                      <span className="path1"></span>
                                      <span className="path2"></span>
                                      <span className="path3"></span>
                                      <span className="path4"></span>
                                      <span className="path5"></span>
                                    </i>
                                    {t("users.createAccount", { email: user.email })}
                                  </button>
                                )}
                            <button
                              className="btn btn-sm btn-primary w-100 mb-3"
                              onClick={()=>setShowUsernameNewModal(user.person_id)}
                            >
                              <i className="ki-duotone ki-arrows-circle fs-4">
                                <span className="path1"></span>
                                <span className="path2"></span>
                                <span className="path3"></span>
                                <span className="path4"></span>
                                <span className="path5"></span>
                              </i>
                              {t("users.connectAnotherLogin")}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )
          ) : (
            <p>{t("users.personNotFound")}</p>
          )}
        </>
      )}
    </>
  );
}

export default SettingsUsers;
